(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('HandbookFolderSearch', HandbookFolderSearch);

    HandbookFolderSearch.$inject = ['$resource'];

    function HandbookFolderSearch($resource) {
        var resourceUrl =  'api/_search/handbook-folders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
